import { helper } from "@/helper";
export default {
  computed: {
    firstName() {
      let userCookie = helper.getUserCookie();
      let firstName =
        userCookie && userCookie.firstName
          ? userCookie.firstName
          : userCookie && userCookie.givenname
          ? userCookie.givenname
          : "";
      if (firstName) return firstName.trim();
      return "";
    },
    lastName() {
      let userCookie = helper.getUserCookie();
      let lastName =
        userCookie && userCookie.lastName
          ? userCookie.lastName
          : userCookie && userCookie.surname
          ? userCookie.surname
          : "";
      if (lastName) return lastName.trim();
      return "";
    },
    fullName() {
      let name = this.firstName;
      if (name.length > 0) name += " ";
      return name + this.lastName;
    },
    isShowListLegend() {
      return (
        this.isShowListHeader &&
        !this.isShowNoData &&
        (this.getConfigItem("SHOW_WAIT_COUNT", true) ||
          this.getConfigItem("SHOW_WAIT_TIMES", true))
      );
    },
  },
  methods: {
    confirmMobile() {
      if (!this.$refs.phoneForm.validate()) {
        return;
      }
      let userCookie = helper.getUserCookie();
      if (!userCookie) userCookie = {};

      userCookie.mobile = this.inputPhonenum;
      this.isMobileConfirmed = true;
      helper.setUserCookie(
        userCookie,
        this.getConfigItem("DATA_RETENTION_PERIOD")
      );

      this.submitRequest();
    },
    validatePhonenum(phonenum) {
      return /^\d{10}$/.test(phonenum) || /^04/.test(phonenum);
    },
    getCustomProperties() {
      if (this.getConfigItem("SET_CUSTOM_PROPERTIES_NULL", true)) {
        let customProperties = null;
        return customProperties;
      }
      let customProperties = {};
      if (process.env.VUE_APP_ISDEBUGGING)
        console.log(
          "getCustomProperties:",
          this.getConfigItem("CUSTOM_PROPERTIES")
        );
      if (!this.getConfigItem("CUSTOM_PROPERTIES")) return customProperties;
      let customPropertiesConfig = null;
      try {
        customPropertiesConfig = JSON.parse(
          this.getConfigItem("CUSTOM_PROPERTIES")
        );
      } catch {
        // sometimes the parse doesn't work, but straight copy its already parsed:
        customPropertiesConfig = this.getConfigItem("CUSTOM_PROPERTIES");
      }
      if (customPropertiesConfig == null) return {};

      let userCookie = helper.getUserCookie();
      for (var i = 0; i < customPropertiesConfig.length; i++) {
        let customFieldName = customPropertiesConfig[i].customProperty;
        let customFieldValue =
          userCookie[customPropertiesConfig[i].payloadField];
        customProperties[customFieldName] = customFieldValue
          ? customFieldValue
          : "";
      }

      return customProperties;
    },
  },
};
